import { Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgControl } from '@angular/forms';

export enum InputStyle {
  default = 'default',
  withBorders = 'withBorders',
}

@Component({
  selector: 'pot-input',
  templateUrl: './pot-input.component.html',
  styleUrls: ['./pot-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PotInputComponent implements OnInit, ControlValueAccessor {
  public controlDir: NgControl | null = inject(NgControl, { optional: true, self: true });

  @Input() public placeholder: string = '';
  @Input() public isDisabled: boolean = false;
  @Input() public type: string = 'text';
  @Input() public maxLength: number = 255;

  @Input() public style: InputStyle = InputStyle.default;

  @Output() public clicked: EventEmitter<any> = new EventEmitter<any>();

  public value: string = '';

  public InputStyle: typeof InputStyle = InputStyle;

  private onChangeCallback!: (value: string) => void;
  private onTouchedCallback!: () => void;

  constructor() {
    const controlDir: NgControl | null = this.controlDir;

    if (controlDir) {
      controlDir.valueAccessor = this;
    }
  }

  public ngOnInit(): void {
    if (this.controlDir) {
      const control: AbstractControl | null = this.controlDir.control;

      if (control && control.validator) {
        control.setValidators(control.validator);
        control.updateValueAndValidity({ emitEvent: false });
      }
    }
  }

  public onTouched(): void {
    if (this.onTouchedCallback) {
      this.onTouchedCallback();
    }
  }

  public onChange(event: KeyboardEvent): void {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    const newValue: string = target.value;

    this.value = newValue;
    this.onChangeCallback(newValue);
  }

  public registerOnChange(fn: (value: string) => any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: () => any): void {
    this.onTouchedCallback = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(value: string): void {
    if (value !== undefined) {
      this.value = value;
    }
  }
}
